import React, { useState } from 'react'
import './Order.css'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { clearAllSnacks } from '../redux/snacks/snacksActions'
import { clearAllFood } from '../redux/food/foodActions'
import { clearAllDrinks } from '../redux/drinks/drinksActions'
import { useAuthContext } from '../hooks/useAuthContext'

const Order = () => {
  const dispatch = useDispatch()
  const {user} = useAuthContext()
  const [error, setError] = useState(null)
    //Snacks
    const burgers = useSelector(state => state.snacks.burgers)
    const burgerPrice = useSelector(state => state.snacks.burgerPrice)
    const fries = useSelector(state => state.snacks.fries)
    const friesPrice = useSelector(state => state.snacks.friesPrice)
    const wraps = useSelector(state => state.snacks.wraps)
    const wrapsPrice = useSelector(state => state.snacks.wrapsPrice)
    const pizzas = useSelector(state => state.snacks.pizzas)
    const pizzasPrice = useSelector(state => state.snacks.pizzasPrice)
    const snackItems = useSelector(state => state.snacks.snackItems)
    //Food
    const biryani = useSelector(state => state.food.biryani)
    const biryaniPrice = useSelector(state => state.food.biryaniPrice)
    const friedRice = useSelector(state => state.food.friedRice)
    const friedRicePrice = useSelector(state => state.food.friedRicePrice)
    const vegBiryani = useSelector(state => state.food.vegBiryani)
    const vegBiryaniPrice = useSelector(state => state.food.vegBiryaniPrice)
    const southMeals = useSelector(state => state.food.southMeals)
    const southMealsPrice = useSelector(state => state.food.southMealsPrice)
    const northMeals = useSelector(state => state.food.northMeals)
    const northMealsPrice = useSelector(state => state.food.northMealsPrice)
    const tandooriChicken = useSelector(state => state.food.tandooriChicken)
    const tandooriChickenPrice = useSelector(state => state.food.tandooriChickenPrice)
    const grillChicken = useSelector(state => state.food.grillChicken)
    const grillChickenPrice = useSelector(state => state.food.grillChickenPrice)
    const foodItems = useSelector(state => state.food.foodItems)

    //Drinks
    const mango = useSelector(state => state.drinks.mango)
    const mangoPrice = useSelector(state => state.drinks.mangoPrice)
    const coldCoffee = useSelector(state => state.drinks.coldCoffee)
    const coldCoffeePrice = useSelector(state => state.drinks.coldCoffeePrice)
    const coffee = useSelector(state => state.drinks.coffee)
    const coffeePrice = useSelector(state => state.drinks.coffeePrice)
    const pepsi = useSelector(state => state.drinks.pepsi)
    const pepsiPrice = useSelector(state => state.drinks.pepsiPrice)
    const drinksItems = useSelector(state => state.drinks.drinksItems)
    const totalItems = snackItems + foodItems + drinksItems

    const products = {'Burgers' : [burgers, burgerPrice], 'Fries' : [fries,friesPrice], 'Wraps' : [wraps,wrapsPrice], 'Pizzas' : [pizzas,pizzasPrice], 'Biryani' : [biryani,biryaniPrice], 'Fried Rice' : [friedRice,friedRicePrice], 'Veg Biryani':[vegBiryani,vegBiryaniPrice], 'South Meals':[southMeals,southMealsPrice], 'North Meals':[northMeals,northMealsPrice], 'Tandoori Chicken':[tandooriChicken,tandooriChickenPrice], 'Grill Chicken':[grillChicken,grillChickenPrice], 'Mango':[mango,mangoPrice], 'Cold Coffee':[coldCoffee,coldCoffeePrice], 'Coffee':[coffee,coffeePrice], 'Pepsi':[pepsi,pepsiPrice] }

    const handleOrder = async () => {
      if(!user) {
        setError('Login / SignUp to Order')
        return
      }

      if(totalItems > 0) {
          // console.log('Order placed!!');
          // console.log({"order" : products})
          
          const res = await fetch('https://myrestaurantmz3699-junaidedmehroz3699.b4a.run/order', {
            method : 'POST',
            body : JSON.stringify({"order" : products}),
            headers : {
              'Content-Type' : 'application/json',
              'Authorization' : `Bearer ${user.token}`
            }
          })
          const data = await res.json()
          // console.log(data);
          // await axios.post('http://localhost:8000/order', {"order" : products})
          dispatch(clearAllSnacks())
          dispatch(clearAllFood())
          dispatch(clearAllDrinks())
          setTimeout(prompt('Order placed Successfully!! Happy Meal :)'), 1000)
        } else {
          prompt('Please choose atleast one item.')
        }
    }
  return (
    <div className='order'>
        {error && <p>{error}</p> }
        <p>Make sure to add all you want!!!!</p>
        <button onClick={handleOrder}>Order</button>
    </div>
  )
}

export default Order